export const classes = {
  badge: 'text-sage-10',
};
